var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_634_1764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 2.70937C19.2518 3.09082 18.4579 3.34101 17.645 3.45157C18.5015 2.86214 19.1424 1.93529 19.4483 0.843579C18.6423 1.39342 17.7602 1.7804 16.8404 1.98769C16.277 1.29929 15.5466 0.821141 14.7438 0.615262C13.941 0.409383 13.1029 0.485266 12.3381 0.833073C11.5733 1.18088 10.9172 1.78456 10.4547 2.56584C9.99226 3.34712 9.74485 4.26996 9.74457 5.21468C9.74403 5.57598 9.77916 5.93618 9.8493 6.28839C8.21772 6.19429 6.62162 5.70714 5.16461 4.85856C3.70761 4.00999 2.42228 2.81897 1.39208 1.36283C0.869195 2.40133 0.710208 3.62952 0.947432 4.79781C1.18466 5.9661 1.80029 6.98682 2.66922 7.65253C2.01838 7.62965 1.38171 7.42849 0.812261 7.0658V7.12447C0.811071 8.21001 1.1363 9.26272 1.73296 10.1046C2.32963 10.9465 3.16111 11.5259 4.08685 11.7449C3.48286 11.9329 2.84948 11.96 2.23499 11.8241C2.49648 12.7607 3.00645 13.5798 3.69349 14.1669C4.38053 14.754 5.21023 15.0796 6.06641 15.0981C4.60952 16.4113 2.80984 17.1223 0.957854 17.1164C0.637752 17.1162 0.31793 17.0946 0 17.0519C1.87709 18.4352 4.06092 19.1694 6.29119 19.167C13.8365 19.167 17.9642 11.9855 17.9642 5.7574C17.9642 5.55498 17.9642 5.35256 17.9642 5.15014C18.7633 4.48134 19.4525 3.65493 20 2.70937Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_634_1764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18.6667,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e1cda67c19089eb539c5251747367739.svg";
export { ForwardRef as ReactComponent };